import { jsx as _jsx } from "react/jsx-runtime";
import { GeneTableCellLink } from '../../components';
const createTableGeneLink = ({ referrerData, levelResult, traitsType, }) => (function TableGeneLink(_, rowData) {
    var _a;
    if (!rowData) {
        throw new Error('No rowData was provided for gene link!');
    }
    // eslint-disable-next-line react/destructuring-assignment
    const geneName = (rowData.geneName) || ((_a = rowData.gene) === null || _a === void 0 ? void 0 : _a.name);
    if (!levelResult) {
        throw new Error('No levelResult was provided for gene link!');
    }
    if (!traitsType) {
        throw new Error('No traitsType was provided for gene link!');
    }
    return (_jsx(GeneTableCellLink, { geneName: geneName, traitsType: traitsType, levelResult: levelResult, referrerData: referrerData }, void 0));
});
export default createTableGeneLink;
